module.exports = __webpack_public_path__ + "static/media/historial_rev_tec.018d0a1c.svg";